module.exports = __webpack_public_path__ + "img/vertical_3_1_9016.5be1dac9.png";